var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "LinkItem",
                _vm._g(
                  {
                    key: "export_ckl",
                    attrs: {
                      text: "Export as DISA Checklist",
                      icon: "mdi-check-all",
                    },
                    on: { click: _vm.showModal },
                  },
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.showingModal,
        callback: function ($$v) {
          _vm.showingModal = $$v
        },
        expression: "showingModal",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "10" } },
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v(" Export as DISA Checklist "),
                  ]),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "2" } },
                [
                  _c("v-checkbox", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover",
                        modifiers: { hover: true },
                      },
                    ],
                    staticClass: "mx-2",
                    attrs: {
                      title:
                        "Attempts to format the profile title into a proper CKL title name",
                      label: "Format Profile Title",
                    },
                    model: {
                      value: _vm.formatProfileTitle,
                      callback: function ($$v) {
                        _vm.formatProfileTitle = $$v
                      },
                      expression: "formatProfileTitle",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                _vm._l(_vm.files, function (file, index) {
                  return _c(
                    "v-col",
                    { key: index, attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-hover", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ hover }) {
                                    return [
                                      _c(
                                        "v-card-title",
                                        {
                                          style: {
                                            cursor: "pointer",
                                            backgroundColor: hover
                                              ? "rgb(80, 80, 80)"
                                              : "rgb(62, 62, 62)",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.toggleSelectFile(file)
                                            },
                                          },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "read-only": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value: file.selected,
                                              callback: function ($$v) {
                                                _vm.$set(file, "selected", $$v)
                                              },
                                              expression: "file.selected",
                                            },
                                          }),
                                          _vm._v(
                                            " " + _vm._s(file.filename) + " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c(
                            "v-expand-transition",
                            [
                              file.selected
                                ? _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c("v-text-field", {
                                            staticClass: "pr-2",
                                            attrs: { label: "Marking" },
                                            model: {
                                              value: file.marking,
                                              callback: function ($$v) {
                                                _vm.$set(file, "marking", $$v)
                                              },
                                              expression: "file.marking",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            staticClass: "pr-2",
                                            attrs: { label: "Host Name" },
                                            model: {
                                              value: file.hostname,
                                              callback: function ($$v) {
                                                _vm.$set(file, "hostname", $$v)
                                              },
                                              expression: "file.hostname",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            staticClass: "pr-2",
                                            attrs: {
                                              label: "Host IP",
                                              "error-messages":
                                                _vm.validateFormat(
                                                  _vm.$v.files.$each[index]
                                                    .hostip,
                                                  "###.###.###.###"
                                                ),
                                              hint: "###.###.###.###",
                                            },
                                            model: {
                                              value: file.hostip,
                                              callback: function ($$v) {
                                                _vm.$set(file, "hostip", $$v)
                                              },
                                              expression: "file.hostip",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            staticClass: "pr-2",
                                            attrs: {
                                              label: "Host MAC",
                                              "error-messages":
                                                _vm.validateFormat(
                                                  _vm.$v.files.$each[index]
                                                    .hostmac,
                                                  "XX:XX:XX:XX:XX:XX"
                                                ),
                                              hint: "XX:XX:XX:XX:XX:XX",
                                            },
                                            model: {
                                              value: file.hostmac,
                                              callback: function ($$v) {
                                                _vm.$set(file, "hostmac", $$v)
                                              },
                                              expression: "file.hostmac",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            staticClass: "pr-2",
                                            attrs: {
                                              label: "Host FQDN",
                                              "error-messages":
                                                _vm.validateFormat(
                                                  _vm.$v.files.$each[index]
                                                    .hostfqdn,
                                                  "[hostname].[domain].[tld]"
                                                ),
                                              hint: "[hostname].[domain].[tld]",
                                            },
                                            model: {
                                              value: file.hostfqdn,
                                              callback: function ($$v) {
                                                _vm.$set(file, "hostfqdn", $$v)
                                              },
                                              expression: "file.hostfqdn",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            attrs: { label: "Target Comments" },
                                            model: {
                                              value: file.targetcomment,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  file,
                                                  "targetcomment",
                                                  $$v
                                                )
                                              },
                                              expression: "file.targetcomment",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c("v-select", {
                                            staticClass: "pr-2",
                                            attrs: {
                                              items: _vm.roles,
                                              label: "Role",
                                            },
                                            model: {
                                              value: file.role,
                                              callback: function ($$v) {
                                                _vm.$set(file, "role", $$v)
                                              },
                                              expression: "file.role",
                                            },
                                          }),
                                          _c("v-select", {
                                            staticClass: "pr-2",
                                            attrs: {
                                              items: _vm.types,
                                              label: "Asset Type",
                                            },
                                            model: {
                                              value: file.assettype,
                                              callback: function ($$v) {
                                                _vm.$set(file, "assettype", $$v)
                                              },
                                              expression: "file.assettype",
                                            },
                                          }),
                                          _c("v-select", {
                                            staticClass: "pr-2",
                                            attrs: {
                                              items: _vm.techareas,
                                              label: "Tech Area",
                                            },
                                            model: {
                                              value: file.techarea,
                                              callback: function ($$v) {
                                                _vm.$set(file, "techarea", $$v)
                                              },
                                              expression: "file.techarea",
                                            },
                                          }),
                                          _c(
                                            "v-select",
                                            {
                                              staticClass: "pr-2",
                                              attrs: {
                                                items: ["id", "gid"],
                                                label: "Vul ID Mapping",
                                              },
                                              model: {
                                                value: file.vulidmapping,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    file,
                                                    "vulidmapping",
                                                    $$v
                                                  )
                                                },
                                                expression: "file.vulidmapping",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    slot: "prepend-inner",
                                                    color: "#332E2E",
                                                    bottom: "",
                                                  },
                                                  slot: "prepend-inner",
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-icon",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "primary",
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  "mdi-information-variant-circle"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "This is what appears in the 'Vul ID' section for each"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " control. By default, the Vul ID is set to the Control ID"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " value as understood in the OHDF schema. If desired, this"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " can be changed to reflect the GID of the control, i.e."
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " the Group ID, which may exist in the Control's tags. If"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " the ID is the same as the GID or the GID does not appear"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " in the tags, the examples listed here may be the same."
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " You can select either field in that case. For this file:"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " Example Control ID: " +
                                                        _vm._s(file.idexample)
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " Example GID: " +
                                                        _vm._s(file.gidexample)
                                                    ),
                                                    _c("br"),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-select", {
                                            attrs: {
                                              items: ["true", "false"],
                                              label: "Web or Database STIG",
                                            },
                                            model: {
                                              value: file.webordatabase,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  file,
                                                  "webordatabase",
                                                  $$v
                                                )
                                              },
                                              expression: "file.webordatabase",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      file.webordatabase === "true"
                                        ? _c(
                                            "v-row",
                                            [
                                              _c("v-text-field", {
                                                staticClass: "pr-2",
                                                attrs: {
                                                  label: "Web or Database Site",
                                                },
                                                model: {
                                                  value: file.webdbsite,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      file,
                                                      "webdbsite",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "file.webdbsite",
                                                },
                                              }),
                                              _c("v-text-field", {
                                                staticClass: "pr-2",
                                                attrs: {
                                                  label:
                                                    "Web or Database Instance",
                                                },
                                                model: {
                                                  value: file.webdbinstance,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      file,
                                                      "webdbinstance",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "file.webdbinstance",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._l(
                                        file.profiles,
                                        function (profile, profileIndex) {
                                          return _c(
                                            "div",
                                            { key: profileIndex },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _vm.formatProfileTitle
                                                    ? _c("v-text-field", {
                                                        staticClass: "pr-2",
                                                        attrs: {
                                                          label: "Name",
                                                          value:
                                                            _vm.setProperName(
                                                              profile.title,
                                                              index,
                                                              profileIndex
                                                            ),
                                                          placeholder:
                                                            profile.titleplaceholder,
                                                        },
                                                      })
                                                    : _c("v-text-field", {
                                                        staticClass: "pr-2",
                                                        attrs: {
                                                          label: "Name",
                                                          value:
                                                            _vm.resetProfileName(
                                                              profile.title,
                                                              index,
                                                              profileIndex
                                                            ),
                                                          placeholder:
                                                            profile.titleplaceholder,
                                                        },
                                                      }),
                                                  _c("v-text-field", {
                                                    staticClass: "pr-2",
                                                    attrs: {
                                                      label: "Version",
                                                      type: "number",
                                                      placeholder:
                                                        profile.versionplaceholder,
                                                    },
                                                    model: {
                                                      value: profile.version,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          profile,
                                                          "version",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "profile.version",
                                                    },
                                                  }),
                                                  _c("v-text-field", {
                                                    staticClass: "pr-2",
                                                    attrs: {
                                                      label: "Release Number",
                                                      type: "number",
                                                      placeholder:
                                                        profile.releasenumberplaceholder,
                                                    },
                                                    model: {
                                                      value:
                                                        profile.releasenumber,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          profile,
                                                          "releasenumber",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "profile.releasenumber",
                                                    },
                                                  }),
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      ref: "profile.showCalendar",
                                                      refInFor: true,
                                                      attrs: {
                                                        "close-on-content-click": false,
                                                        transition:
                                                          "scale-transition",
                                                        "offset-y": "",
                                                        "min-width": "auto",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                              attrs,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        staticClass:
                                                                          "pr-2",
                                                                        attrs: {
                                                                          label:
                                                                            "Release Date",
                                                                          "prepend-inner-icon":
                                                                            "mdi-calendar",
                                                                          readonly:
                                                                            "",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            profile.releasedate,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                profile,
                                                                                "releasedate",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "profile.releasedate",
                                                                        },
                                                                      },
                                                                      "v-text-field",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  )
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          profile.showCalendar,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            profile,
                                                            "showCalendar",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "profile.showCalendar",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-date-picker",
                                                        {
                                                          attrs: {
                                                            id: "release-date-datepicker",
                                                            "no-title": "",
                                                            scrollable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              profile.releasedate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                profile,
                                                                "releasedate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "profile.releasedate",
                                                          },
                                                        },
                                                        [
                                                          _c("v-spacer"),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                text: "",
                                                                color:
                                                                  "primary",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.setDateSelection(
                                                                      index,
                                                                      profileIndex,
                                                                      profile.releasedate
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v(" Save ")]
                                                          ),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                text: "",
                                                                color:
                                                                  "primary",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.clearDateSelection(
                                                                      index,
                                                                      profileIndex
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v(" Clear ")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.closeModal } },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    text: "",
                    disabled: !_vm.selected.length || _vm.$v.$invalid,
                  },
                  on: { click: _vm.exportCKL },
                },
                [_vm._v(" Export ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }